import { render, staticRenderFns } from "./FangYuanEdit.vue?vue&type=template&id=10993032&scoped=true"
import script from "./FangYuanEdit.vue?vue&type=script&lang=js"
export * from "./FangYuanEdit.vue?vue&type=script&lang=js"
import style0 from "./FangYuanEdit.vue?vue&type=style&index=0&id=10993032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10993032",
  null
  
)

export default component.exports